export default "__VITE_ASSET__0a657ad3__"